const drawerStyles = (theme) => ({
  display: { xs: "block", md: "block" },
  "& .MuiDrawer-paper": {
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    width: "28%",
    [theme.breakpoints.down("sm")]: {
      width: "75%",
    },
    p: "10px",
  },
});

const mainBoxStyles = { display: "flex", justifyContent: "space-between" };

const avataStyles = { bgcolor: "#E4F2E8", width: "58px", height: "58px" };

const svgIconStyle = { color: "black", width: "40px", height: "40px" };

const buttonBoxStyles = {
  position: "absolute",
  bottom: "0px",
  padding:"20px",
  width: "97%",
  display: "flex",
  justifyContent: "space-between",
  alignContent: "center",
  background:"#fff"
};
const buttonBoxStyles2 = {
  position: "absolute",
  bottom: "0px",
  padding:"20px",
  width: "97%",
  display: "flex",
  justifyContent: "space-between",
  alignContent: "center",
  background:"#fff",
  justifyContent: "right"
};
const lockButtonStyles = { bgcolor: "#EEEEEE", width: "170px", height: "38px" };

const lockIconStyles = { color: "black", width: "20px", height: "20px", marginRight: "10px"};

export {
  drawerStyles,
  mainBoxStyles,
  avataStyles,
  svgIconStyle,
  buttonBoxStyles,
  buttonBoxStyles2,
  lockButtonStyles,
  lockIconStyles,
};
